import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { colors } from 'shared/defaultTheme';

const Paragraph = styled.p(({ color }) => ({
  color: `${color} !important`,
}));

const CustomSpan = styled.span(({ color }) => ({
  color: `${color} !important`,
}));

export const LabelError = ({ label, className }) => (
  <span className={classNames(['label-error', className])}>{label}</span>
);

LabelError.defaultProps = {
  className: '',
};

LabelError.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export const LabelInput = ({ label, className, error, color }) => (
  <CustomSpan
    className={classNames({ 'label-input--error': error }, ['label-input', className])}
    color={color}
  >
    {label}
  </CustomSpan>
);

LabelInput.defaultProps = {
  className: '',
  error: false,
  color: undefined,
};

LabelInput.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
  color: PropTypes.string,
};

export const LabelRequiredInput = ({ label, color, className, error }) => (
  <Paragraph
    className={classNames({ 'label-input--error': error }, ['label-input', className])}
    color={error ? colors.error : color}
  >
    {label}
    <span className="required-mark"> *</span>
  </Paragraph>
);

LabelRequiredInput.defaultProps = {
  className: '',
  error: false,
};

LabelRequiredInput.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
};

export const LabelIcon = ({
  label,
  className,
  classNameMain,
  Icon,
  color,
  isStyle = true,
  isDashboard,
}) => (
  <LabelIconContainer
    className={classNames(['label-icon__main'], classNameMain)}
    isDashboard={isDashboard}
  >
    {Icon &&
      (isStyle ? (
        <LabelIconHome color={color} isDashboard={isDashboard}>
          <Icon />
        </LabelIconHome>
      ) : (
        <Icon />
      ))}
    <span className={classNames([className])}>{label}</span>
  </LabelIconContainer>
);

const LabelIconHome = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const LabelIconContainer = styled.section`
  cursor: ${({ isDashboard }) => (isDashboard ? 'initial' : 'pointer')};
  &:hover {
    span {
      color: ${({ isDashboard }) => (isDashboard ? colors.suvaGrey : colors.black)};
    }
    div {
      background-color: ${({ isDashboard, color }) => (isDashboard ? colors.suvaGrey : color)};
    }
  }
`;

LabelIcon.defaultProps = {
  className: '',
  classNameMain: '',
  Icon: undefined,
  isStyle: undefined,
  isDashboard: false,
};

LabelIcon.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNameMain: PropTypes.string,
  Icon: PropTypes.func,
  color: PropTypes.string.isRequired,
  isStyle: PropTypes.bool,
  isDashboard: PropTypes.bool,
};
